import AttendanceIcon from "icons/AttendanceIcon";
import CalendarIcon from "icons/CalendarIcon";
import CodeIcon from "icons/CodeIcon";
import PeopleIcon from "icons/PeopleIcon";

export const HEADERS_TABLE_LIST = [
	{ title: "Código de alumno", icon: <CodeIcon /> },
	{ title: "Apellidos y Nombres", icon: <PeopleIcon /> },
	{ title: "Estado de alumno", icon: <PeopleIcon /> },
	{ title: "Fecha de Inscripción", icon: <CalendarIcon /> },
	{
		title: "Asistencia",
		icon: <AttendanceIcon />,
	},
];
export const HEADERS_TABLE_LIST_SANCIONADOS = [
	{ title: "Código de alumno", icon: <CodeIcon /> },
	{ title: "Apellidos y Nombres", icon: <PeopleIcon /> },
	{ title: "Estado de alumno", icon: <PeopleIcon /> },
	{ title: "Fecha de Inscripción", icon: <CalendarIcon /> },
	{ title: "Fecha de Sanción", icon: <CalendarIcon /> },
];
export const ERROR_TEXTS_ADD_STUDENT_RESERVATION = {
	"LIMITE_ALCANZADO": "Ya alcanzaste el límite de estudiantes agregados." 
};